import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";

import AuthCard from "../../components/auth/AuthCard";
import { loginStore } from "../../stores/loginStore";
import { usePageTitle } from "../../utils/usePageTitle";

import "./PasswordRecoveryPage.css";

export const PasswordResetDonePage = observer(function PasswordResetDonePage() {
  const { t } = useTranslation();
  usePageTitle(t("passwordRecovery.done.title"));

  return (
    <AuthCard>
      <h1>{t("passwordRecovery.done.title")}</h1>
      <p>{t("passwordRecovery.done.description1")}</p>
      <p>
        {t("passwordRecovery.done.description2")}{" "}
        <a href="mailto:support@nextgis.com">support@nextgis.com</a>
      </p>
      <div style={{ marginTop: 16, fontSize: 14 }}>
        <Trans
          i18nKey="passwordRecovery.done.goBack"
          components={{
            lnk: <Link to="/login/1" state={{ email: loginStore.email }} />,
          }}
        />
      </div>
    </AuthCard>
  );
});
